module.exports = __webpack_public_path__ + "static/media/294654.a728cfdf.png";